import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { GET_MATERAILS, GET_MATERAIL_INSPECTION } from "./type";

export const fetchMaterials = () => async (dispatch) => {
    const res = await callWebService(
        callTypes.get,
        "",
        Config.maintenance.fetchMaterials
    );
    if (res) {
        const { data } = res;
        dispatch({ type: GET_MATERAILS, payload: data.response.data });
        return data.response.data;
    }
};

export const saveMaterialInspection = (data) => async (dispatch) => {
    const res = await callWebService(
      callTypes.post,
      data,
      Config.maintenance.saveMaterialInspection
    );
    if (res?.data?.response?.status === true) {
        const { data } = res;
      dispatch({ type: "", payload: data.response.data });
      return true;
    }
};

export const fetchMaterialInspection = (id=null) => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      `${Config.maintenance.fetchMaterialInspection}/?id=${id}`
    );
    if (res) {
        const { data } = res;
        dispatch({ type: GET_MATERAIL_INSPECTION, payload: data.response.data });
        return data.response.data;
    }
};

export const materialInspected = () => async (dispatch) => {
    const res = await callWebService(
      callTypes.get,
      "",
      Config.maintenance.materialInspected
    );
    if (res) {
        const { data } = res;
        return data.response.data;
    }
};

